/* eslint-disable react-hooks/exhaustive-deps */
import _ from "lodash";
import { useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getPageSizeParams } from "./useDefaultForm";
import { useFetch } from "./useFetch";
import { useQueryClient } from "react-query";

export function usePaginatedFilterUrl(
  queryKey,
  fetcher,
  converterPayload,
  defaultFormValues,
  formValues = defaultFormValues,
  hasPage = true
) {
  const history = useNavigate();
  const location = useLocation();

  const path = location.pathname;
  const search = location.search;

  const { params } = getPageSizeParams(search);

  const { page: pageTmp = 1, size: sizeTmp = 10 } = formValues;
  const page = pageTmp < 1 ? 1 : pageTmp;
  const size = sizeTmp < 1 || sizeTmp > 100 ? 10 : sizeTmp;

  const pageValue = page - 1;

  useEffect(() => {
    if (hasPage) {
      params.set("page", page);
      params.set("size", size);
    }
    history(`${path}?${params.toString()}`);
  }, [page, size]);

  useEffect(() => {
    if (formValues) {
      params.set(
        "filter",
        JSON.stringify(_.omit(formValues, ["page", "size"]))
      );
      history(`${path}?${params.toString()}`);
    }
  }, [formValues]);

  const requestData = useMemo(() => {
    if (page > 0 && size > 0 && size <= 100) {
      const rs = converterPayload(formValues);
      return hasPage ? { ...rs, page: pageValue, size } : rs;
    }
  }, [page, size, formValues]);

  const result = useFetch(fetcher, requestData, queryKey, {
    enabled: !!requestData,
    payloadNotAsKey: true,
  });

  useEffect(() => {
    if (requestData) {
      result.refetch();
    }
  }, [requestData]);

  useEffect(() => {
    const totalElements = result?.data?.totalElements;

    if (totalElements) {
      const pageTmp = _.ceil(totalElements / size);
      const pageMax = pageTmp < 1 ? 1 : pageTmp;

      if (pageMax < page) {
        if (hasPage) {
          // @ts-ignore
          params.set("page", pageMax);
        }
        const url = `${path}?${params.toString()}`;
        history(url);
        // @ts-ignore
        history.go(0);
      }
    }
  }, [result?.data?.totalElements]);

  const _dataFilter = _.map(result.data?.content, (x, index) => {
    const stt = size * pageValue + index + 1;
    return { ...x, stt: stt, key: stt };
  });

  return {
    ...result,
    data: hasPage ? _dataFilter : result.data,
    defaultPageCurrent: page,
    totalRecord: result.data?.totalElements,
    defaultPage: { page, size },
    isLoading: result.isLoading,
    isFetching: result.isFetching,
    requestData,
    refetch: result.refetch,
  };
}
